<!-- 填写并核对订单信息 -->
<template>
    <div id="getOrderInfo" class="business-content-main">
        <div class="order-info-title">填写并核对订单信息</div>
        <div class="order-info-main">
            <div class="step-tit">
                <div class="item-title">
                    收货人信息
                </div>
                <div class="add-address" @click="showAddress">
                    新增收货地址
                </div>
            </div>
            <div class="address-ctn" :class="{'address-open':addressOpen}">
                <div class="address-item"
                     v-for="(item,index) in addressList"
                     :key="item.Id"
                     @click="toggleAddress(item,index)"
                >
                    <div class="add-item" :class="{'target-checked':addressIndex == index}" style="width: 144px">
                        <span>{{item.Tags}}</span>
                        <span class="gou"></span>
                    </div>
                    <div class="add-dir">{{item.Contactor}}</div>
                    <div class="add-dir">{{item.Province}}{{item.City}}{{item.District}}{{item.Addr}}</div>
                    <div class="add-dir">{{item.PhoneNum}}</div>
                    <div class="add-dir default-address" v-if="item.IsDefault">默认地址</div>
                    <div class="ops-ctn">
                        <span @click.stop="setDefault(item)" v-if="!item.IsDefault">设为默认地址</span>
                        <span @click.stop="addressEdit(item)">编辑</span>
                        <span @click.stop="addressDel(item)">删除</span>
                    </div>
                </div>
            </div>
            <div class="open-btn">
                <span @click="openAddress(1)" v-if="addressOpen">展开</span>
                <span @click="openAddress(0)" v-else>收起</span>
            </div>
            <div class="send-goods-list">
                <div class="step-tit">
                    <div class="item-title">
                        送货清单
                    </div>
                    <div class="add-address">
                        <span @click="gotoBuyCar">返回修改</span>
                    </div>
                </div>
                <div class="send-goods-list-main">
                    <div class="dataList" >
                        <div :key="index" class="data-item" v-for="(item,index) in dataList">
                            <!-- 优惠活动 -->
                            <div class="activity"
                                  v-if="item.SinglePromotion || item.BuyGivePromotion || item.FullDiscountPromotion || item.ExchangeBuyPromotion"
                            >
                                <!-- 单品促销 -->
                                <template v-if="item.SinglePromotion">
                                    <template v-if="item.SinglePromotion.DiscountType == 0">
                                        <div class="promotion-item">
                                            <div class="promotion-type">折扣</div>
                                            <div class="promotion-dir">{{item.SinglePromotion.DiscountValue}}折</div>
                                        </div>
                                    </template>
                                    <template v-else-if="item.SinglePromotion.DiscountType == 1">
                                        <div class="promotion-item">
                                            <div class="promotion-type">直降</div>
                                            <div class="promotion-dir">{{item.SinglePromotion.DiscountValue}}元</div>
                                        </div>
                                    </template>
                                    <template v-else-if="item.SinglePromotion.DiscountType == 2">
                                        <div class="promotion-item">
                                            <div class="promotion-type">折后价</div>
                                            <div class="promotion-dir">{{item.SinglePromotion.DiscountValue}}元</div>
                                        </div>
                                    </template>
                                </template>
                                <!-- 买送 -->
                                <template v-if="item.BuyGivePromotion">
                                    <div class="promotion-item">
                                        <div class="promotion-type">买送</div>
                                        <div class="promotion-dir">买{{item.BuyGivePromotion.BuyCount}}送{{item.BuyGivePromotion.SendCount}}</div>
                                    </div>
                                </template>
                                <!-- 满减 -->
                                <template v-if="item.FullDiscountPromotion">
                                    <div class="promotion-item">
                                        <div class="promotion-type">满减</div>
                                        <div class="promotion-dir">
                                            满{{item.FullDiscountPromotion.LimitMoney1}}减{{item.FullDiscountPromotion.CutMoney1}}
                                            <template v-if="item.FullDiscountPromotion.LimitMoney2">
                                                满{{item.FullDiscountPromotion.LimitMoney2}}减{{item.FullDiscountPromotion.CutMoney2}}
                                            </template>
                                            <template v-if="item.FullDiscountPromotion.LimitMoney3">
                                                满{{item.FullDiscountPromotion.LimitMoney3}}减{{item.FullDiscountPromotion.CutMoney3}}
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <!-- 换购促销 -->
                                <template v-if="item.ExchangeBuyPromotion">
                                    <div class="promotion-item">
                                        <div class="promotion-type">换购</div>
                                        <div class="promotion-dir">
                                            满{{item.ExchangeBuyPromotion.LimitMoney}}加{{item.ExchangeBuyPromotion.AddMoney}}可换购
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <!-- 主体商品》套装 -->
                            <div class="tz-goods-show" v-if="item.isSuit">
                                <div class="activity">
                                    <div class="promotion-item">
                                        <div class="promotion-type">套装</div>
                                    </div>
                                </div>
                                <div style="display: flex">
                                    <div style="flex-grow: 1">
                                        <div :key="index" v-for="(suit,index) in item.PackageGoodsList">
                                            <div class="goods-main">
                                                <div class="image-ctn shop-cover">
                                                    <img :src="down_url + suit.ShowImg" mode="widthFix">
                                                </div>
                                                <div class="goods-message hg-goods-message">
                                                    <div class="goods-name" :title="suit.Name">
                                                        {{suit.Name}}
                                                    </div>
                                                    <div class="hg-price">
                                                        <div class="color-red">￥{{suit.zhMoney}}</div>
                                                        <div>
                                                            x{{suit.Number}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 赠品 -->
                                            <div class="zp-goods-show" v-if="suit.GiftPromotion">
                                                <div :key="index" class="goods-main hg-goods-main" v-for="(gift,index) in suit.GiftPromotion.GiftGoodsList">
                                                    <div class="image-ctn suit-gift-image-ctn">
                                                        <img :src="down_url + gift.ShowImg" mode="aspectFill">
                                                    </div>
                                                    <div class="goods-message hg-goods-message">
                                                        <div class="goods-name" :title="gift.Name">
                                                            <span class="goods-type-icon">赠品</span>{{gift.Name}}
                                                        </div>
                                                        <div class="hg-price">
                                                            <div class="color-red">￥0</div>
                                                            <div>
                                                                x{{gift.Number}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="suit-num">
                                    套装价：
                                    <div class="color-red">￥{{item.zhMoneySuit}}</div>
                                    <div>x{{item.BuyCount}}</div>
                                </div>
                            </div>
                            <!-- 主体商品》单个商品 -->
                            <div class="goods-main" @click="gotoDetails(item.GoodsId)" v-else>
                                <div class="image-ctn shop-cover">
                                    <img :src="down_url + item.ShowImg" mode="aspectFill">
                                </div>
                                <div class="goods-message">
                                    <div class="goods-name" :title="item.Name">{{item.Name}}</div>
                                    <div class="goods-price">
                                        <div>￥{{item.zhMoney}}</div>
                                        <div>
                                            <div>x{{item.BuyCount}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 换购商品 -->
                            <div class="hg-goods-show" v-if="item.hgGoods.Name">
                                <div class="goods-main hg-goods-main">
                                    <div class="image-ctn hg-image-ctn">
                                        <img :src="down_url + item.hgGoods.ShowImg">
                                    </div>
                                    <div class="goods-message hg-goods-message">
                                        <div class="goods-name" :title="item.hgGoods.Name">
                                            <span class="goods-type-icon">加价购</span>{{item.hgGoods.Name}}
                                        </div>
                                        <div class="hg-price">
                                            <div class="color-red">￥{{item.hgGoods.ShopPrice}}</div>
                                            <div>
                                                x1
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 买送商品 -->
                            <div class="ms-goods-show" v-if="item.canMs">
                                <div class="goods-main hg-goods-main">
                                    <div class="image-ctn hg-image-ctn">
                                        <img :src="down_url + item.ShowImg">
                                    </div>
                                    <div class="goods-message hg-goods-message">
                                        <div class="goods-name" :title="item.Name">
                                            <span class="goods-type-icon">买送</span>{{item.Name}}
                                        </div>
                                        <div class="hg-price">
                                            <div class="color-red">￥0</div>
                                            <div>
                                                x{{item.msNum}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 赠品 -->
                            <div class="zp-goods-show" v-if="item.GiftPromotion">
                                <div :key="index" class="goods-main hg-goods-main" v-for="(gift,index) in item.GiftPromotion.GiftGoodsList">
                                    <div class="image-ctn hg-image-ctn">
                                        <img :src="down_url + gift.ShowImg">
                                    </div>
                                    <div class="goods-message hg-goods-message">
                                        <div class="goods-name" :title="gift.Name">
                                            <span class="goods-type-icon">赠品</span>{{gift.Name}}
                                        </div>
                                        <div class="hg-price">
                                            <div class="color-red">￥0</div>
                                            <div>
                                                x{{gift.Number}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 优惠 -->
            <div class="coupon" :class="{'coupon-open':couponOpen}">
                <div class="item-title">使用优惠券</div>
                <el-table
                        :show-header="showHeader"
                        :data="couponList"
                        style="width: 100%">
                    <el-table-column
                            show-overflow-tooltip
                            prop="Name">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row|couponHandle}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                有效期{{scope.row.UseDate}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-checkbox v-model="scope.row.checked" @change="handleCouponChange(scope.$index)"></el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="open-btn">
                <span @click="openCoupon(1)" v-if="couponOpen">收起</span>
                <span @click="openCoupon(0)" v-else>展开</span>
            </div>
            <div class="money-count">
                <div>
                    <p v-if="dataList">
                        <span class="key">总商品金额:</span>
                        <span class="value">￥{{countMoney}}</span>
                    </p>
                    <p>
                        <span class="key">
                             <el-tooltip class="item" effect="light">
                                 <div slot="content">订单可能会产生运费<br>如果产生运费会有客服与您沟通具体细节</div>
                                <i class="el-icon-question" style="color: orange"></i>
                             </el-tooltip>
                            运费:
                        </span>
                        <span class="value">￥0.00</span>
                    </p>
                    <p>
                        <span class="key">商品优惠:</span>
                        <span class="value">￥{{favorable}}</span>
                    </p>
                </div>
            </div>
            <div class="trade-foot-detail-com">
                <div>应付总额：<span class="price-num">￥{{finalMoney}}</span> </div>
                <div>
                    <span>寄送至： {{chooseAddress.Province}}{{chooseAddress.City}}{{chooseAddress.District}}{{chooseAddress.Addr}} </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>收货人：{{chooseAddress.Contactor}} {{chooseAddress.PhoneNum}}</span>
                </div>
            </div>
            <div class="sub-btn-ctn">
                <div class="sub-btn" @click="submitData">提交订单</div>
            </div>
        </div>
        <!--   换购弹窗   -->
        <el-dialog
                :close-on-click-modal="false"
                width="800px"
                title="选择换购商品"
                :visible.sync="showHg">
            <div class="goods-main hg-goods" v-for="(item,index) in hgList" :key="index">
                <div style="width:50px">
                    <el-checkbox v-model="item.checked"></el-checkbox>
                </div>
                <div style="width:400px">
                    <div class="order-msg">
                        <img :src="downloadUrl + item.ShowImg" class="gift-cover">
                        <div :title="item.Name">
                            {{item.Name}}
                        </div>
                    </div>
                </div>
                <div style="width:80px">
                    ￥{{item.ShopPrice}}&nbsp;&nbsp;&nbsp;&nbsp; x1
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showHg = false">取 消</el-button>
                <el-button class="btn-primary" @click="addHg">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                title="地址"
                :before-close="handleClose"
                :visible.sync="dialogVisible"
                custom-class="base-dialog"
                width="800px"
        >
            <addAddress
                    ref="addAddress"
                    :submitType="addressType"
                    :addrData="this.addressData"
                    :areaSelect="this.areaSelect"
                    @resetData="clearDialog"
                    @loadData="changeAddress">
            </addAddress>
        </el-dialog>
    </div>
</template>
<script>
    import addAddress from '@/components/common/addAddress'
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {
            addAddress,
        },
        data(){
            let userMsg = this.$util.getLocalStorage("userMsg");
            return {
                userMsg:userMsg,
                canRequest:true,
                noAddress:false,
                showPromotion:false, // 促销
                DeliveryMethod:'', // 配送方式
                freight:0, // 运费
                zhMoney:0, // 折后单价
                chosenCoupon:[], // 选中的优惠券，目前是单选，但还是写成数组吧
                countNum:0,
                favorable:0,    // 优惠
                countMoney:0,   // 原价
                finalMoney:0,// 最终实付价格
                couponList:[],  // 可选优惠券列表
                receiveAddress:{}, // 地址
                showCoupon:false,
                showLayer:false,
                down_url:this.$util.QN_URL_BASE,
                downloadUrl:this.$util.QN_URL_BASE,
                searchData:{
                    UserId:true,
                    GoodsId:'',
                    GoodsType:'',
                },
                dataList:[],
                promotionLayer:{},  // 促销弹窗数据

                GoodsTypeId:'',
                canMs:false, // 是否可以买送
                msNum:1,     // 满送数量
                hgGoods:{},  // 换购商品信息
                canHg:false, // 是否可以换购
                hgList:[],      // 换购
                showHg:false,

                couponOpen:false,
                showHeader:false,
                invoiceVisible:false,
                addressType:1, //
                dialogVisible:false,
                addressList:[],
                addressIndex:0,
                addressOpen:true,
                addressData:{},
                areaSelect:[],  // 地址三级联动
                chooseAddress:{}, // 选中的地址
            }
        },
        mounted(){
            this.initPage()
        },
        filters:{
            couponHandle(item){
                if(item.Type == 0){
                    return `付款时代现金${item.CValue}元`
                }
                else if (item.Type == 1){
                    return `付款时订单打${item.CValue}折`
                }
                else if(item.Type == 3){
                    return `满${item.OrderAmountLower}减${item.CValue}元`
                }
            },
        },
        methods:{
            gotoDetails(){

            },
            // 提交订单
            submitData(){
                if(!this.chooseAddress.Id){
                    this.$util.warningMsg('请选择地址')
                    return
                }
                let DetailList =[]
                let dataList = this.dataList
                for(let i = 0;i<dataList.length;i++){
                    let _data = {
                        "goodsId": '',
                        "goodsType": '',
                        "exchangeBuyPromotionId": dataList[i].hgGoods.GoodsId?dataList[i].ExchangeBuyPromotion.ExchangeBuyPromotionId:'',
                        "exchangeBuyGoodsId":  dataList[i].hgGoods.GoodsId?dataList[i].hgGoods.GoodsId:'',
                        "buyQuantity": dataList[i].BuyCount
                    }
                    if(dataList[i].isSuit){
                        _data.goodsId = dataList[i].PackagePromotionId
                        _data.goodsType = 10
                    }
                    else {
                        _data.goodsId = dataList[i].GoodsId
                        _data.goodsType = 5
                    }
                    DetailList.push(_data)
                }
                if (!this.canRequest){
                    return;
                }
                this.canRequest = false
                this.$util.axiosPost({
                    url:'/api/MallSaleOrder/SubmitShoppingCartSaleOrder',
                    data:{
                        "UserId": this.userMsg.EmployeeId,
                        "addressId": this.chooseAddress.Id,
                        "couponIds": this.chosenCoupon[0]?this.chosenCoupon[0].CouponId:'',
                        "DetailList":DetailList
                    }
                }).then((res)=>{
                    this.$util.clearLocalStorage('shopCar')
                    this.$util.clearLocalStorage('carCount')
                    this.canRequest = true
                    this.$router.push(`./pay?osn=${res.data}`)
                }).catch(()=>{
                    this.canRequest = true
                })

            },
            handleClose(){
                this.$refs.addAddress.resetForm()
                this.dialogVisible = false
            },
            clearDialog(){
                this.$refs.addAddress.resetForm()
                this.dialogVisible = false
            },
            handleCouponChange(index){
                this.chosenCoupon = []
                let _data = this.couponList
                if (!_data[index].checked){
                    this.chosenCoupon = []
                    for (let i = 0;i<_data.length;i++){
                        this.$set(this.couponList[i],'checked',false)
                    }
                }
                else {
                    for (let i = 0;i<_data.length;i++){
                        this.$set(this.couponList[i],'checked',false)
                    }
                    // 判断这张券能不能用
                    let _chosen = this.couponList[index]
                    if(_chosen.Type == 3){
                        if(this.countMoney < _chosen.OrderAmountLower){
                            this.$util.warningMsg('不满足领取条件')
                            return
                        }
                    }
                    this.$set(this.couponList[index],'checked',true)
                    this.chosenCoupon[0] = this.couponList[index]
                }
                this.countData()
            },
            openCoupon(flag){
                if (flag){
                    this.couponOpen = false
                }
                else {
                    this.couponOpen = true
                }
            },
            // 绑定换购商品
            addHg(){
                let  flag = false
                let _hgList = this.hgList
                for (let i = 0;i< _hgList.length;i++){
                    if(_hgList[i].checked){
                        this.hgGoods = _hgList[i]
                        flag =true
                    }
                }
                if (!flag){
                    this.hgGoods = {}
                }
                this.showHg = false
                this.countData()
            },
            initPage(){
                this.getAddressList()
                this.getData()
            },
            // 获取数据
            getData(){
                let data = this.$util.getLocalStorage('shopCar')
                this.dataList = data
                let _ShoppingCartGoodsIds = []
                let _PackagePromotionIds = []
                for(let i=0;i<data.length;i++){
                    if(data[i].isSuit){
                        _PackagePromotionIds.push(data[i].PackagePromotionId)
                    }
                    else {
                        _ShoppingCartGoodsIds.push(data[i].ShoppingCartGoodsId)
                    }
                }
                let _ShoppingCartGoodsIdsStr = _ShoppingCartGoodsIds.join(',')
                let _PackagePromotionIdsStr = _PackagePromotionIds.join(',')
                this.$util.axiosGet({
                    url:'/api/MallShoppingCart/GetShoppingCartConfirmationGoodsList',
                    data:{
                        UserId:this.userMsg.EmployeeId,
                        ShoppingCartGoodsIds:_ShoppingCartGoodsIdsStr,
                        PackagePromotionIds:_PackagePromotionIdsStr,
                    }
                }).then((res)=>{
                    this.couponList = res.data.CouponList
                    this.freight = res.data.Freight
                    this.DeliveryMethod = res.data.DeliveryMethod
                })
                this.countData()
            },
            // 商品价格和优惠统计
            countData(){
                let data = this.$util.getLocalStorage('carCount')
                this.finalMoney = data.checkedPrice
                this.countMoney = data.originalPrice
                // 算优惠券
                if(this.chosenCoupon[0]){
                    if(this.chosenCoupon[0].Type == 3){
                        if(this.finalMoney < this.chosenCoupon[0].OrderAmountLower){
                            let _data = this.couponList
                            for (let i = 0;i<_data.length;i++){
                                _data[i].checked = false
                            }
                            this.chosenCoupon = [{Type:-1}]
                        }
                    }
                    //优惠券类型（0 代金券；1 折扣券；2 积分兑换券（暂不考虑）；3满减券）
                    if (this.chosenCoupon[0].Type == 0){
                        this.finalMoney = this.$util.num2Float(this.finalMoney -  this.chosenCoupon[0].CValue)
                    }
                    else if(this.chosenCoupon[0].Type == 1){
                        this.finalMoney = this.$util.num2Float(this.finalMoney *  this.chosenCoupon[0].CValue * 0.1)
                    }
                    // else if(this.chosenCoupon[0].Type == 2){

                    // }
                    else if(this.chosenCoupon[0].Type == 3){
                        this.finalMoney = this.$util.num2Float(this.finalMoney -  this.chosenCoupon[0].CValue)
                    }
                    else if(this.chosenCoupon[0].Type == -1){
                        this.finalMoney = this.finalMoney
                    }
                }
                this.favorable = this.$util.num2Float(data.originalPrice - this.finalMoney)
            },
            // 单品促销处理
            SinglePromotionHandle(Promotion,price){
                if(Promotion.DiscountType == 0){
                    return price * Promotion.DiscountValue * 0.1
                }
                else if(Promotion.DiscountType == 1){
                    return price - Promotion.DiscountValue
                }
                else if(Promotion.DiscountType == 2) {
                    return Promotion.DiscountValue
                }
            },
            // 地址添加成功后要进行的操作
            changeAddress(type,data){
                this.getAddressList();
                this.clearDialog()
            },
            // 关闭发票
            closeInvoice(){
                this.invoiceVisible = false
            },
            // 显示发票
            editInvoice(){
                this.invoiceVisible = true
            },
            // 设为默认地址
            setDefault(data){
                this.$util.axiosPost({
                    url:'/api/PurchaseManager/SetASDefaultAddress',
                    data:{
                        "addrId": data.Id,
                        "entpId": this.userMsg.EntpId,
                        "operator": this.userMsg.EmployeeId,
                    },
                }).then(()=>{
                    this.getAddressList()
                })
            },
            // 编辑
            addressEdit(data){
                this.addressType = 2
                this.addressData = data
                this.areaSelect = [data.Province,data.City,data.District]
                this.dialogVisible = true
            },
            // 删除
            addressDel(data){
                let that = this
                this.$util.elConfirm({
                    content:'确定要删除该地址吗？',
                    confirm(){
                        that.$util.axiosGet({
                            url:'/api/EntpInfoManagement/DeleteAddress',
                            data:{
                                AddrId:data.Id,
                                Uid:that.userMsg.EmployeeId,
                            },
                        }).then(()=>{
                            that.getAddressList()
                        })
                    },
                })
            },

            // 展开收起地址
            openAddress(flag){
                if (flag){
                    this.addressOpen = false
                }
                else {
                    this.addressOpen = true
                }
            },
            // 切换地址
            toggleAddress(item,index){
                this.addressList.splice(index,1)
                this.addressList.unshift(item)
                this.addressOpen = true
                this.chooseAddress = item
            },
            // 获取地址列表
            getAddressList(){
                this.$util.axiosGet({
                    url:'/api/EntpInfoManagement/GetAddressList',
                    data:{
                        EntpId:this.userMsg.EntpId
                    },
                }).then((res)=>{
                    let data = res.data
                    this.addressList = data
                    this.chooseAddress = data[0]
                })
            },
            // 跳转购物车
            gotoBuyCar (){
                window.history.back(-1);
            },
            // 显示新增地址弹窗
            showAddress(){
                this.dialogVisible = true
            },
        }
    }
</script>
<style lang="less" scoped>
    .shop-cover {
        width: 100px;
        height: 100px;
        overflow: hidden;
        img {
            max-width: 100px;
            max-height: 100px;
        }
    }
    .gift-cover {
        width: 50px;
        height: 50px;
        margin-right: 20px;
        margin-left: 30px;
        img {
            max-width: 50px;
            max-height: 50px;
        }
    }
    .suit-num {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 593px;
        >div:nth-child(1){
            font-size: 20px;
            font-weight: bold;
            margin-right: 10px;
        }
    }
    .goods-price,.hg-price {
        width: 100px;
        text-align: right;
        display: flex;
        align-items: center;
        >div:nth-child(1){
            color: red;
            font-size: 16px;
            font-weight: bold;
            margin-right: 20px;
        }
        >div:nth-child(2){
            font-size: 12px;
        }
    }
    .hg-goods-main {
        padding: 10px 0;
    }
    .hg-image-ctn {
        margin-left: 30px;
        img {
            max-width: 70px;
            max-height: 70px;
        }
    }
    .suit-gift-image-ctn {
        margin-left: 30px;
        img {
            max-width: 70px;
            max-height: 70px;
        }
    }
    .dataList {
        flex-grow: 1;
    }
    .send-goods-list-main {
        background: #F2F6FC;
        padding: 20px;
    }
    .data-item {
        padding: 10px 0;
        border-bottom:1px dashed @border1Color ;
    }
    .goods-name {
        margin-right: 20px;
        width: 520px;
        line-clamp:3;
        -webkit-line-clamp: 3;
    }
    .goods-price {
        display: flex;
    }
    .goods-message {
        display: flex;
    }
    .goods-main {
        display: flex;
    }
    .hg-goods {
        display: flex;
        align-items: center;
    }
    .show-hg-btn {
        cursor: pointer;
    }
    .order-msg {
        display: flex;
        padding: 20px;
        justify-content: space-between;
        align-items: center;
    }
    .gift-type {
        padding-left: 70px;
    }
    .goods-type-icon {
        border: 1px solid red;
        background:#ffdedf;
        color: red;
        padding: 0 5px;
        border-radius: 5px;
        margin-right: 5px;
    }
    .gift-cover {
        width: 50px;
        height: 50px;
        margin-right: 20px;
        margin-left: 30px;
    }
    .activity {
        display: flex;
        padding: 5px 0;
    }
    .promotion-item {
        display: flex;
        margin-right: 20px;
    }
    .promotion-dir {
        height: 20px;
        line-height: 20px;
        margin-right: 5px;
    }
    .promotion-type {
        background: red;
        color: white;
        width: 50px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 5px;
    }
    .coupon-open {
        height: auto !important;
    }
    .goods-cover {
        width: 100px;
        height: 100px;
        border: 1px solid @border3Color;
    }
    .toggle-item {
        display: none;
    }
    .business-content-main {
        margin: 0 auto;
        max-width: 1200px;
    }
    .pay-way-item {
        min-width: 140px;
        width: auto !important;
        margin-bottom: 10px;
    }
    .address-item {
        position: relative;
        &:hover {
            background: @border3Color;
            .ops-ctn {
                display: template;
            }
        }
        .ops-ctn {
            display: none;
            position: absolute;
            line-height: 26px;
            top: 0;
            right: 0;
            span {
                cursor:pointer;
                color: #005ea7;
                margin-left: 10px;
            }
        }
    }
    .address-open {
        height: 46px;
    }
    .address-ctn {
        overflow: hidden;
    }
    .sub-btn-ctn {
        text-align: right;
        padding-bottom: 30px;
    }
    .sub-btn {
        text-align: center;
        position: relative;
        width: 135px;
        height: 36px;
        line-height: 36px;
        margin: 8px 0 0;
        background-color: @theme;
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        font-family: arial,"Microsoft YaHei";
        display: inline-block;
        border-radius: 3px;
        cursor: pointer;
    }
    .price-num {
        color: #e4393c;
        font-family: Verdana;
        font-weight: 700;
        font-size: 18px;
        min-width: 122px;
        width: 122px;
    }
    .trade-foot-detail-com {
        background: @border3Color;
        padding: 10px;
        text-align: right;
        >div {
            margin-bottom: 20px;
        }
    }
    .money-count {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
        padding-right: 10px;
        span {
            display: inline-template;
        }
        p {
            padding-bottom: 20px;
        }
        .key {
            width: 200px;
            text-align: right;
        }
        .value {
            width: 100px;
            text-align: right;
        }
    }
    .coupon-money {
        width: 100%;
        background-color:@border3Color;
        display: template;
        clear: both;
        height: 38px;
        margin-top: 15px;
        padding: 10px 20px;
        font-size: 12px;
    }
    .couponLv2Tab {
        padding: 20px 0;
        display: flex;
        >div {
            cursor: pointer;
            margin-right:50px;
        }
    }
    .tabLv2-active {
        border-bottom: 2px solid @theme;
        color: @theme;
    }
    .coupon-type {
        margin-top: 20px;
        border: 1px solid @border3Color;
    }
    .coupon-tab {
        display: flex;
        background: @border3Color;
        >div {
            cursor: pointer;
            width: 100px;
            height: 38px;
            line-height: 38px;
            text-align: center;
        }
    }
    .item-title {
        font-weight: bold;
        padding-bottom: 20px;
    }
    .coupon {
        padding-top: 20px;
        height: 100px;
        overflow: hidden;
    }
    .edit-invoice {
        cursor: pointer;
        color: #005ea7;
    }
    .invoice-type {
        padding-top: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid @border3Color;
        >span {
            display: inline-template;
            margin-right: 30px;
        }
    }
    .triangle{
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-right: 10px solid @border3Color;
        border-bottom: 8px solid transparent;
    }
    .invoice-title {
        font-weight: bold;
        margin-right: 10px;
    }
    .invoice-msg {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid @border3Color;
        display: flex;
        align-items: center;
        .tooltip {
            border-radius: 5px;
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            background: @border3Color;
            font-size: 12px;
        }
    }
    .add-dir {
        padding-right: 30px;
    }
    .goods-inventory {
        width: 80px;
        text-align: right;
    }
    .goods-num {
        padding-left: 20px;
        width: 170px;
        text-align: right;
    }
    .goods-price {
        width: 100px;
        text-align: right;
        >p:nth-child(1){
            color: red;
            font-size: 16px;
            font-weight: bold;
        }
        >p:nth-child(2){
            font-size: 12px;
        }
    }
    .goods-item {
        display: flex;
        align-items: center;
        padding-right: 20px;
        margin:10px 0;
        padding-bottom:10px ;
        border-bottom: 1px solid @border2Color;
    }
    .goods-dir {
        width: 300px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0 10px 20px;
    }
    .goods-weight {
        position: absolute;
        left: 20px;
        bottom: 10px;
        font-weight: bold;
    }
    .business-content-main {
        min-width: 1000px;
    }
    .mode-tab-nav {
        display: flex;
        margin: 10px 0 20px;
    }
    .order-info-title {
        height: 42px;
        line-height: 42px;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        overflow: hidden;
    }
    .order-info-main {
        border:1px solid @border3Color;
        padding: 0 20px;
    }
    .step-tit {
        line-height: 40px;
        height: 40px;
        color: #333;
        display: flex;
        justify-content: space-between;
    }
    .add-address {
        color: #005ea7;
        cursor: pointer;
    }
    .default-address {
        color: white;
        background: @font3Color;
        padding: 5px;
    }
    .pay-way-ctn {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding-bottom: 10px;
    }
    .send-goods-list-main {
        display: flex;
        position: relative;
    }
    .send-way {
        width: 300px;
        background: @border3Color;
        padding: 10px 10px 30px 20px;
    }
    .goods-list {
        flex-grow:1;
        background: @border4Color;
        padding: 20px;
    }
    .open-btn {
        cursor: pointer;
        color: @theme;
    }
    .coupon-title {
        color: @theme;
        padding: 20px 0 10px 0;
        font-size: @font-sm;
    }
</style>
